<template>
  <div class="paid-excel" style="color: #000 !important;">
    <el-dialog
      :title="generateCustomizeString('batchExportOrders')"
      :visible.sync="paidExcelVisible"
      width="90%"
    >
      <el-button
        v-if="isOrderStatus === -1"
        type="primary"
        class="button"
        @click="downloadFile()"
      >{{ generateCustomizeString('exportExcel') }}</el-button>
      <el-button
        v-else
        type="primary"
        class="button"
        v-popover:popover
      >{{ generateCustomizeString('exportExcel') }}</el-button>
      <el-popover
        ref="popover"
        v-model="paidExcelPopoverVisible"
        placement="right-start"
        width="200"
        trigger="click"
      >
        <p>{{ generateCustomizeString('statusChangeToPickingOnceExported') }}</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="paidExcelPopoverVisible = false"
          >{{ generateCustomizeString('cancel') }}</el-button>
          <el-button
            type="primary"
            size="mini"
            @click="downloadFile()"
          >{{ generateCustomizeString('confirm') }}</el-button>
        </div>
      </el-popover>
      <el-checkbox
        v-model="includeSku"
        style="margin-left: 50px;"
        size="large"
        border
      >{{ generateCustomizeString('includeSKU') }}</el-checkbox>
      <el-checkbox
        v-model="includeComments"
        style="margin-left: 0;"
        size="large"
        border
      >{{ generateCustomizeString('includeComments') }}</el-checkbox>
      <el-table :data="showData" tooltip-effect="dark" border>
        <el-table-column
          :label="generateCustomizeString('orderId')"
          prop="out_trade_no"
          width="150"
        ></el-table-column>
        <el-table-column
          :label="generateCustomizeString('orderStatus')"
          prop="status_name"
          width="150"
        ></el-table-column>
        <el-table-column
          :label="generateCustomizeString('customerName')"
          prop="customer_name"
          width="140"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.customer_name }}
            </div>
            <div v-if="scope.row.customer.remark">({{ scope.row.customer.remark }})</div>
          </template>
        </el-table-column>
        <el-table-column
          :label="generateCustomizeString('orderGoods')"
          prop="order_goods"
          width="300"
        >
          <template slot-scope="scope">
            <div v-for="item in scope.row.order_goods" :key="item.product_full_name">
              <span>
                <span>{{ item.product_abbreviation }} *{{ item.quantity }};&nbsp;&nbsp;&nbsp;</span>
                <span v-if="includeSku">(sku: {{ item.goods_sku_id }})</span>
              </span>
              <!-- <span v-if="includeSku === false">
                <span>{{item.product_abbreviation}} *{{item.quantity}};&nbsp;&nbsp;&nbsp;</span>
              </span> -->
              <!-- <span v-else>
                <span>{{item.product_full_name}} *{{item.quantity}};&nbsp;&nbsp;&nbsp;</span>
              </span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="generateCustomizeString('orderCreateAt')"
          prop="created_at"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.created_at | toLocalTime}}</template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('isPickUp')" prop="is_pick_up">
          <template
            slot-scope="scope"
          >{{ scope.row.is_pick_up === 1 ? generateCustomizeString('pickup') : generateCustomizeString('post')}}</template>
        </el-table-column>

        <el-table-column :label="generateCustomizeString('shippingPerson')" prop="order_address">
          <template slot-scope="scope">
            <span v-if="scope.row.is_pick_up === 0">{{scope.row.order_address.consignee_name}}</span>
            <span v-else>{{ generateCustomizeString('isPickUp') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('recipientPhone')" prop="order_address">
          <template slot-scope="scope">
            <span v-if="scope.row.is_pick_up === 0">{{scope.row.order_address.phone}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('shippingAddress')" prop="order_address">
          <template slot-scope="scope">
            <span v-if="scope.row.is_pick_up === 0">{{scope.row.order_address.address_detail}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('identityNumber')" prop="order_address">
          <template slot-scope="scope">
            <span v-if="scope.row.is_pick_up === 0">{{scope.row.order_address.person_id}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('senderName')">
          <template slot-scope="scope">
            <div v-if="scope.row.is_pick_up === 0">
              <span
                v-if="scope.row.order_sender && scope.row.order_sender.sender_name"
              >{{scope.row.order_sender.sender_name}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('senderPhone')">
          <template slot-scope="scope">
            <div v-if="scope.row.is_pick_up === 0">
              <span
                v-if="scope.row.order_sender && scope.row.order_sender.phone"
              >{{scope.row.order_sender.phone}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('senderAddress')">
          <template slot-scope="scope">
            <div v-if="scope.row.is_pick_up === 0">
              <span
                v-if="scope.row.order_sender && scope.row.order_sender.address"
              >{{scope.row.order_sender.address}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('amountofGoods')" width="150">
          <template slot-scope="scope">
            <span>{{scope.row.goods_fee | formatPrice}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('shippingFee')" width="150">
          <template slot-scope="scope">
            <span>{{scope.row.express_fee | formatPrice}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('totalFee')" width="150">
          <template slot-scope="scope">
            <span>{{scope.row.fee | formatPrice}}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="includeComments === true"
          :label="generateCustomizeString('orderComment')"
        >
          <template slot-scope="scope">
            <span>{{scope.row.comment}}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="includeComments === true"
          :label="generateCustomizeString('customerMessage')"
        >
          <template slot-scope="scope">
            <span>{{scope.row.message}}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="includeComments === true"
          :label="generateCustomizeString('sellerComments')"
        >
          <template slot-scope="scope">
            <span>{{scope.row.to_customer_message}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column :label="generateCustomizeString('receiver')" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.is_pick_up === 0">{{ scope.row.order_address.consignee_name }}</span>
          </template>
        </el-table-column>-->
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import XLSX from 'xlsx'
import XLSX_SAVE from 'file-saver'
import { generateCustomizeString } from '@/utils/i18n'
import dayjs from 'dayjs'

export default {
  name: 'PaidExcel',
  props: {
    isOrderStatus: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      paidExcelVisible: false,
      paidExcelPopoverVisible: false,
      outFile: '',
      ids: '',
      showData: [],
      exportDataNotIncludeSkuComments: [],
      exportDataIncludeSkuComments: [],
      exportDataIncludeSkuNotComments: [],
      exportDataIncludeCommentsNotSku: [],
      includeSku: false,
      includeComments: false
    }
  },
  mounted() {
    this.outFile = document.getElementById('downlink')
  },
  methods: {
    generateCustomizeString,
    handleExcelClick(ids) {
      // this.includeSku = false
      // 清空数据
      this.showData = []
      this.exportDataNotIncludeSkuComments = []
      this.exportDataIncludeSkuComments = []
      this.exportDataIncludeSkuNotComments = []
      this.exportDataIncludeCommentsNotSku = []
      this.ids = ids

      request({
        url: '/order/picking/' + ids,
        method: 'get'
      })
        .then(response => {
          this.paidExcelVisible = true
          const data = response.data
          this.showData = data

          // 处理 good 内容
          for (var i = 0; i < data.length; i++) {
            let goods = ''
            for (var j = 0; j < data[i].order_goods.length; j++) {
              goods =
                goods +
                data[i].order_goods[j].product_abbreviation +
                ' *' +
                data[i].order_goods[j].quantity +
                ', ' +
                '\n\t'
            }
            // 移除最后一个商品结尾的逗号
            goods = goods.replace(/,\s*$/, '')
            // goods = goods.toString()
            let goodsSku = ''
            for (var s = 0; s < data[i].order_goods.length; s++) {
              goodsSku =
                goodsSku +
                data[i].order_goods[s].product_full_name +
                ' *' +
                data[i].order_goods[s].quantity +
                '(sku:' +
                data[i].order_goods[s].goods_sku_id +
                ')' +
                ', ' +
                '\n\t'
            }
            // 移除最后一个商品结尾的逗号
            goodsSku = goodsSku.replace(/,\s*$/, '')

            const item = {
              [this.generateCustomizeString('orderId')]: data[i].out_trade_no
                ? 'No. ' + data[i].out_trade_no
                : 'N/A',
              [this.generateCustomizeString('orderStatus')]: data[i]
                .status_name,
              [this.generateCustomizeString('orderType')]:
                data[i].is_pick_up === 1 ? 'Pick up' : 'Shipping',
              [this.generateCustomizeString(
                'orderCreateAt'
              )]: this.$options.filters.toLocalTime(data[i].created_at),
              [this.generateCustomizeString('customerName')]:
                data[i].customer.remark ? data[i].customer_name + '\r\n' +
                '(' + data[i].customer.remark + ')' : data[i].customer_name,
              [this.generateCustomizeString('orderGoods')]: 'N/A',
              // [this.generateCustomizeString('orderMessage')]: data[i].message
              //   ? data[i].message
              //   : 'N/A',
              [this.generateCustomizeString('receiver')]: 'N/A',
              [this.generateCustomizeString('receiverPhone')]: 'N/A',
              [this.generateCustomizeString('shippingAddress')]: 'N/A',
              [this.generateCustomizeString('identityCard')]: 'N/A',
              [this.generateCustomizeString('senderName')]: 'N/A',
              [this.generateCustomizeString('senderPhone')]: 'N/A',
              [this.generateCustomizeString('senderAddress')]: 'N/A',
              [this.generateCustomizeString(
                'amountofGoods'
              )]: this.$options.filters.formatPrice(data[i].goods_fee),
              [this.generateCustomizeString(
                'shippingFee'
              )]: this.$options.filters.formatPrice(data[i].express_fee),
              [this.generateCustomizeString(
                'totalFee'
              )]: this.$options.filters.formatPrice(data[i].fee)
            }

            if (data[i].is_pick_up !== 1) {
              item[this.generateCustomizeString('receiver')] = data[i]
                .order_address.consignee_name
                ? data[i].order_address.consignee_name
                : 'N/A'
              item[this.generateCustomizeString('receiverPhone')] = data[i]
                .order_address.phone
                ? 'Tel: ' + data[i].order_address.phone
                : 'N/A'
              item[this.generateCustomizeString('shippingAddress')] = data[i]
                .order_address.address_detail
                ? data[i].order_address.address_detail
                : 'N/A'
              item[this.generateCustomizeString('identityCard')] = data[i]
                .order_address.person_id
                ? 'ID: ' + data[i].order_address.person_id
                : 'N/A'

              item[this.generateCustomizeString('senderName')] = data[i]
                .order_sender
                ? data[i].order_sender.sender_name
                : 'N/A'
              item[this.generateCustomizeString('senderPhone')] = data[i]
                .order_sender
                ? 'Tel: ' + data[i].order_sender.phone
                : 'N/A'
              item[this.generateCustomizeString('senderAddress')] = data[i]
                .order_sender
                ? data[i].order_sender.address
                : 'N/A'
            }

            // Include Sku Comments or not
            const includeSkuCommentsItem = JSON.parse(JSON.stringify(item))
            const notIncludeSkuCommentsItem = JSON.parse(JSON.stringify(item))
            const includeSkuNotCommentsItem = JSON.parse(JSON.stringify(item))
            const notSkuIncludeCommentsItem = JSON.parse(JSON.stringify(item))

            includeSkuCommentsItem[
              this.generateCustomizeString('orderGoods')
            ] = goodsSku
            includeSkuCommentsItem[
              this.generateCustomizeString('orderComment')
            ] = data[i].comment
            includeSkuCommentsItem[
              this.generateCustomizeString('customerMessage')
            ] = data[i].message
            includeSkuCommentsItem[
              this.generateCustomizeString('sellerComments')
            ] = data[i].to_customer_message

            notIncludeSkuCommentsItem[
              this.generateCustomizeString('orderGoods')
            ] = goods

            includeSkuNotCommentsItem[
              this.generateCustomizeString('orderGoods')
            ] = goodsSku

            notSkuIncludeCommentsItem[
              this.generateCustomizeString('orderGoods')
            ] = goods
            notSkuIncludeCommentsItem[
              this.generateCustomizeString('orderComment')
            ] = data[i].comment
            notSkuIncludeCommentsItem[
              this.generateCustomizeString('customerMessage')
            ] = data[i].message
            notSkuIncludeCommentsItem[
              this.generateCustomizeString('sellerComments')
            ] = data[i].to_customer_message

            this.exportDataIncludeSkuComments.push(includeSkuCommentsItem)
            console.log(this.exportDataIncludeSkuComments)
            this.exportDataNotIncludeSkuComments.push(notIncludeSkuCommentsItem)
            this.exportDataIncludeSkuNotComments.push(includeSkuNotCommentsItem)
            this.exportDataIncludeCommentsNotSku.push(notSkuIncludeCommentsItem)
          }
        })
        .catch(error => {
          console.warn(error)
        })
    },
    updateOrder() {
      request({
        url: '/order/picking/' + this.ids,
        method: 'patch',
        params: {
          status: 15
        }
      })
        .then(response => {
          this.$emit('onRefersh')
        })
        .catch(error => {
          console.warn(error)
        })
    },
    downloadFile() {
      const fileName = dayjs()
        .local()
        .format('YYYY-MM-DD_HH-mm-ss')

      /* make the worksheet */
      var ws = null

      if (this.includeSku) {
        if (this.includeComments) {
          ws = XLSX.utils.json_to_sheet(this.exportDataIncludeSkuComments, {
            skipHeader: false
          })
        } else {
          ws = XLSX.utils.json_to_sheet(this.exportDataIncludeSkuNotComments, {
            skipHeader: false
          })
        }
      } else {
        if (this.includeComments) {
          ws = XLSX.utils.json_to_sheet(this.exportDataIncludeCommentsNotSku, {
            skipHeader: false
          })
        } else {
          ws = XLSX.utils.json_to_sheet(this.exportDataNotIncludeSkuComments, {
            skipHeader: false
          })
        }
      }

      /* write workbook (use type 'binary') */
      var csv = XLSX.utils.sheet_to_csv(ws)

      /* prepend UTF-8 BOM */
      const str = '\ufeff' + csv

      /* force a download */
      XLSX_SAVE.saveAs(
        new Blob([str], { type: 'application/octet-stream' }),
        'Order_Data_' + fileName + '.csv'
      )
      this.paidExcelPopoverVisible = false
      this.paidExcelVisible = false
      if (this.isOrderStatus === 10) {
        this.updateOrder()
      }
    },
    s2ab: function(s) {
      // 字符串转字符流
      var buf = new ArrayBuffer(s.length)
      var view = new Uint8Array(buf)
      for (var i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    },
    getCharCol: function(n) {
      // 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
      let s = ''
      let m = 0
      while (n > 0) {
        m = (n % 26) + 1
        s = String.fromCharCode(m + 64) + s
        n = (n - m) / 26
      }
      return s
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-table th > .cell {
  text-align: center;
}

.button {
  margin-bottom: 20px;
}

.paid-excel .el-popover {
  z-index: 1000001 !important;
}
</style>
